import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { catalog } from '@/mocks/catalog';
import { formatViews, ratingLabel } from '@/utils/format';

const ranked = [...catalog].sort((a, b) => b.views - a.views).slice(0, 8);

export default function HotRankList() {
  return (
    <section aria-label="热门影视推荐">
      <SectionHeading
        title="热门影视推荐"
        subtitle="根据站内热度排序的高关注作品"
        icon="ri-fire-line"
        moreTo="/category/movie"
        moreLabel="更多热门"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        {ranked.map((item, i) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex items-center gap-3 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
          >
            <span
              className={`w-7 text-center font-heading font-extrabold text-lg shrink-0 ${
                i < 3 ? 'text-accent-500' : 'text-foreground-300'
              }`}
            >
              {i + 1}
            </span>
            <span className="w-14 h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
              <img
                src={item.poster}
                alt={`${item.title}海报`}
                title={`${item.title} - ${item.genres.join(' ')}`}
                className="w-full h-full object-cover object-top"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </span>
                <span className="shrink-0 text-xs font-label font-bold text-accent-600">
                  {ratingLabel(item.rating)}
                </span>
              </span>
              <span className="block mt-1 text-xs text-foreground-500 truncate">
                {item.genres.slice(0, 3).join(' / ')}
              </span>
              <span className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-play-circle-line"></i>
                  {formatViews(item.views)}
                </span>
                <span>{item.year}</span>
                <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800">
                  {item.type === 'movie' ? '电影' : '剧集'}
                </span>
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}